import React from 'react';
import { makeStyles } from '@material-ui/core';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import config from '../../../preorder/configs/config';
import { COUPON_APPLICABLE_CHANNEL_STRING_MAP } from '../../const';

const useStyles = makeStyles((theme) => ({
  root: {
    borderRadius: 8,
    boxShadow: '0px 0px 5px 0px rgba(157,157,157,0.5)',
    display: 'flex',
    overflow: 'hidden',
    padding: ({ index }) => (index ? theme.spacing(2.75, 2) : theme.spacing(1)),
    position: 'relative',
    backgroundColor: ({ isPriority }) => (isPriority ? '#e5e5e5' : 'transparent'),
    width: '100%',
    cursor: ({ disabled }) => (disabled ? 'normal' : 'pointer'),
  },
  imageContainer: {
    alignItems: 'center',
    display: 'flex',
    flexBasis: 0,
    flexGrow: 1,
    flexShrink: 0,
    justifyContent: 'center',
    maxWidth: 200,
  },
  image: {
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    paddingTop: '92.3%',
    width: '100%',
  },
  content: {
    display: 'flex',
    flexBasis: 0,
    flexDirection: 'column',
    flexGrow: 2,
    flexShrink: 0,
    marginLeft: theme.spacing(1.5),
  },
  descriptionContainer: {
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    flexShrink: 1,
    fontSize: 14,
    marginTop: theme.spacing(0.5),
  },
  title: {
    flexShrink: 0,
    fontSize: 16,
    fontWeight: 'bold',
  },
  tag: {
    backgroundColor: '#f9cb00',
    color: 'black',
    fontSize: 10,
    fontWeight: 'bold',
    position: 'absolute',
    right: '5%',
    textAlign: 'center',
    top: 0,
    width: 70,

    '&::before': {
      borderColor: '#f9cb00 transparent transparent transparent',
      borderStyle: 'solid',
      borderWidth: '8px 35px 0 0',
      content: "''",
      height: 0,
      left: 0,
      position: 'absolute',
      top: '100%',
      width: 0,
    },
    '&::after': {
      borderColor: '#f9cb00 transparent transparent transparent',
      borderStyle: 'solid',
      borderWidth: '8px 0 0 35px',
      content: "''",
      height: 0,
      right: 0,
      position: 'absolute',
      top: '100%',
      width: 0,
    },
  },
  used: {
    backgroundColor: '#e5e5e5',

    '&::before': {
      borderColor: '#e5e5e5 transparent transparent transparent',
    },
    '&::after': {
      borderColor: '#e5e5e5 transparent transparent transparent',
    },
  },
  ad: {
    backgroundColor: 'green',
    color: 'white',

    '&::before': {
      borderColor: 'green transparent transparent transparent',
    },
    '&::after': {
      borderColor: 'green transparent transparent transparent',
    },
  },
  index: {
    backgroundColor: '#f9cb00',
    left: '5%',
    width: 30,
    color: 'black',

    '&::before': {
      borderColor: '#f9cb00 transparent transparent transparent',
      borderWidth: '8px 15px 0 0px',
    },
    '&::after': {
      borderColor: '#f9cb00 transparent transparent transparent',
      borderWidth: '8px 0 0 15px',
    },
  },
  spacing: {
    flexGrow: 1,
    minHeight: 4,
  },
  mask: {
    backgroundColor: '#e5e5e5',
    opacity: 0.5,
    height: '100%',
    left: 0,
    position: 'absolute',
    top: 0,
    width: '100%',
  },
}));

export default ({
  applicableChannel,
  coverImage,
  description,
  disabled = false,
  expirationTimeString,
  gotTimeString,
  id,
  index,
  isAd,
  isPriority,
  isUsed,
  onClick,
  title,
}) => {
  const classes = useStyles({
    disabled,
    isPriority,
    index,
  });

  return (
    <div
      className={classes.root}
      onClick={() => {
        onClick(id);
      }}
    >
      {index > 0
      && <div className={[classes.tag, classes.index].join(' ')}>{index}</div>}
      {disabled
      && <div className={classes.mask} />}
      {isAd
      && <span className={[classes.tag, classes.ad].join(' ')}>活動</span>}
      {isPriority
      && <span className={classes.tag}>優先使用</span>}
      {isUsed
      && <span className={[classes.tag, classes.used].join(' ')}>已使用</span>}
      <div
        className={classes.imageContainer}
      >
        <LazyLoadComponent>
          <div
            className={classes.image}
            style={{ backgroundImage: `url(${config.RESOURCE_URI}${coverImage})` }}
          />
        </LazyLoadComponent>
      </div>
      <div className={classes.content}>
        <span className={classes.title}>{title}</span>
        <div className={classes.descriptionContainer}>
          <span>{description}</span>
          <div className={classes.spacing} />
          {gotTimeString && (
          <span>{`獲得時間：${gotTimeString}`}</span>
          )}
          {expirationTimeString && (
          <span>{`使用期限：${expirationTimeString}`}</span>
          )}
          {applicableChannel && (
          <span>{`適用範圍：${COUPON_APPLICABLE_CHANNEL_STRING_MAP[applicableChannel] || ''}`}</span>
          )}
        </div>
      </div>
    </div>
  );
};
